import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

const CountryFilterSelector = ({ regions, value, onChange }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      label={t('Países')}
      fullWidth
      menuItems={regions?.map(r => ({ label: r.name, value: r.code }))}
      value={value}
      handleChange={e => onChange(e.target.value)}
    />
  )
}

export default CountryFilterSelector
